import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const reasons = [{
  title: 'Pastillas y Químicos',
  desc: 'No curan el sueño, solo te noquean, dejándote una "resaca" de fatiga al día siguiente que arruina tu productividad.'
}, {
  title: 'Alcohol Antes de Dormir',
  desc: 'Te ayuda a "caer", pero fragmenta tu sueño profundo y te garantiza un despertar ansioso de madrugada.'
}, {
  title: 'Apps de Meditación',
  desc: 'No están diseñadas para un cerebro masculino bajo estrés corporativo o familiar; son demasiado pasivas para frenar un tren de pensamientos a alta velocidad.'
}];
export function WhyItDidntWork() {
  return <section className="w-full bg-midnight-deep py-24 px-6 border-y border-cyan-signal/10" data-id="element-244">
      <div className="max-w-6xl mx-auto" data-id="element-245">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-246">
          <h2 className="font-display text-3xl md:text-5xl text-bone uppercase leading-tight" data-id="element-247">
            Por qué nada de lo que <br className="hidden md:block" data-id="element-248" />
            has probado funciona
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-249">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-midnight p-8 border border-alert/20 relative" data-id="element-250">
              <div className="absolute top-0 left-0 w-full h-1 bg-alert/50" data-id="element-251" />
              <div className="w-12 h-12 bg-alert/10 rounded-none flex items-center justify-center mb-6" data-id="element-252">
                <X className="w-6 h-6 text-alert" data-id="element-253" />
              </div>
              <h3 className="text-xl font-bold text-bone mb-4 uppercase tracking-wide" data-id="element-254">
                {reason.title}
              </h3>
              <p className="text-steel leading-relaxed" data-id="element-255">{reason.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}